module.exports = __webpack_public_path__ + "img/ic_dots_menu.961d0743.svg";